import React from 'react';
import Table from 'react-bootstrap/Table';

const H2hAllTable = ({
  h2hData,
  bookLogos,
  getBookLogoUrl,
  getCellStyle,
  getTooltipText,
  onOddsClick,
  game,
  oddsCellStyle,
  periodsToShow = null  // If null, show all periods. Otherwise, array of periods to display (e.g., ['Game'], ['Q1','Q2','Q3','Q4'], ['1st Half','2nd Half'])
}) => {
  const safeGame = { away: 'TBD', home: 'TBD', gameIDmlb: 'loading', ...game };

  if (!h2hData || h2hData.length === 0) {
    return null;
  }

  // Group players by period
  const groupedByPeriod = h2hData.reduce((acc, player) => {
    const period = player.period || 'Game';
    if (!acc[period]) {
      acc[period] = [];
    }
    acc[period].push(player);
    return acc;
  }, {});

  // Define period order
  const periodOrder = ['Game', 'Q1', 'Q2', 'Q3', 'Q4', '1st Half', '2nd Half', '1st', '2nd', '3rd'];

  // Filter periods based on periodsToShow prop
  let periodsToDisplay = Object.keys(groupedByPeriod);
  if (periodsToShow && Array.isArray(periodsToShow)) {
    periodsToDisplay = periodsToDisplay.filter(period => periodsToShow.includes(period));
  }

  const sortedPeriods = periodsToDisplay.sort((a, b) => {
    const indexA = periodOrder.indexOf(a);
    const indexB = periodOrder.indexOf(b);
    return (indexA === -1 ? 999 : indexA) - (indexB === -1 ? 999 : indexB);
  });

  return (
    <div className="table-container">
      <Table bordered size="sm" className="text-center">
        <thead>
          <tr><th colSpan={bookLogos.length + 1} style={{ backgroundColor: 'transparent', color: 'rgb(245, 158, 11)', fontWeight: 'bold' }}>Moneylines (All Periods)</th></tr>
          <tr>
            <th style={{ width: '120px' }}>Team</th>
            {bookLogos.map(book => (
              <th key={`h2h-${book}`} style={oddsCellStyle}>
                <img
                  src={getBookLogoUrl(book)}
                  alt={`${book} logo`}
                  title={book}
                  style={{ height: '20px' }}
                />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {sortedPeriods.map((period, periodIndex) => (
            <React.Fragment key={period}>
              {/* Period section header */}
              <tr>
                <td colSpan={bookLogos.length + 1} style={{
                  backgroundColor: 'transparent',
                  color: '#ffc107',
                  fontWeight: 'bold',
                  textAlign: 'center',
                  padding: '8px',
                  borderTop: 'none',
                  borderBottom: 'none'
                }}>
                  {period === 'Game' ? 'Moneyline' : `Moneyline ${period}`}
                </td>
              </tr>
              {/* Teams for this period */}
              {groupedByPeriod[period].map((player) => (
                <tr key={player.tierKey || player.id}>
                  <td style={{ width: '120px', fontWeight: 'bold' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px' }}>
                      {player.team !== 'draw' && (
                        <img
                          src={player.team === 'away' ? safeGame.awayLogo : safeGame.homeLogo}
                          alt={player.team === 'away' ? safeGame.away : safeGame.home}
                          style={{ width: '20px', height: '20px' }}
                          onError={(e) => {
                            e.target.style.visibility = 'hidden';
                            e.target.style.width = '0px';
                            e.target.style.height = '0px';
                            e.target.style.margin = '0px';
                          }}
                        />
                      )}
                      <span>
                        {player.team === 'draw'
                          ? 'Draw'
                          : player.team === 'away'
                            ? (safeGame.awayNickname || safeGame.away)
                            : (safeGame.homeNickname || safeGame.home)
                        }
                      </span>
                    </div>
                  </td>
                  {bookLogos.map(book => (
                    <td
                      key={`h2h-${book}`}
                      className="odds-cell"
                      onClick={() => {
                        if (player[`h2h_${book}`] && onOddsClick) {
                          onOddsClick(safeGame.gameIDmlb, null, player.team, 'h2h', book, player[`h2h_${book}`], safeGame.away, safeGame.home);
                        }
                      }}
                      style={{
                        ...getCellStyle(
                          player[`h2h_${book}`],
                          player[`h2h_bestBookPrice`],
                          player[`h2h_bestBookDiff`],
                          bookLogos.filter(b => player[`h2h_${b}`] !== null && player[`h2h_${b}`] !== undefined).length,
                          player[`h2h_${book}_direction`]
                        ),
                        textAlign: 'center',
                        padding: '8px 4px',
                        cursor: player[`h2h_${book}`] ? 'pointer' : 'default'
                      }}
                      title={getTooltipText(
                        player[`h2h_${book}`],
                        player[`h2h_bestBookPrice`],
                        player[`h2h_bestBookDiff`],
                        bookLogos.filter(b => player[`h2h_${b}`] !== null && player[`h2h_${b}`] !== undefined).length
                      )}
                    >
                      {player[`h2h_${book}`] ? (
                        <span style={{ fontSize: '0.9rem', fontWeight: 'bold' }}>
                          {player[`h2h_${book}`] > 0 ? `+${player[`h2h_${book}`]}` : player[`h2h_${book}`]}
                        </span>
                      ) : null}
                    </td>
                  ))}
                </tr>
              ))}
            </React.Fragment>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default H2hAllTable;
